<template>
<div fluid class="pa-0">
  <div class="pa-4" :style="'z-index: 0;position: relative;height:400px;background-image: linear-gradient(0deg,' + $bgColor + '0%,' + $bgColor2 + '100%); border-radius: 0px 0px 50px 50px;width:device-width '">
      <div :style="'height: 143px;background-color:' + $bgColor2 + ';width: 143px;border-radius: 100px;position: absolute;z-index: -1;right: 14px;top: -52px;'" class="bubble4"></div>
      <div :style="'height: 90px;background-color:' + $bgColor2 + ';width: 45px;border-top-left-radius: 110px;border-bottom-left-radius: 110px;position: absolute;z-index: -1;right: 1px;top: 29px;'" class="bubble3"></div>
      <div :style="'height: 89px;background-color:' + $bgColor3 + ';width: 89px;border-radius: 100px;position: absolute;z-index: -1;right: 17px;top: 58px;'" class="bubble2"></div>
      <div :style="'height: 89px;background-color:' + $bgColor3 + ';width: 89px;border-radius: 100px;position: absolute;z-index: -1;right: 73px;top: 70px;'" class="bubble1"></div>
    <div class="d-flex justify-content-between">
      <v-btn v-show="back" class="ms-4"  :style="'background-color:' + $textcolor + ';border-radius:40px'" @click="backBtn">
        <v-icon :style="'color:' + $bgColor">mdi-arrow-left</v-icon>
      </v-btn>
      <strong style="color:#fff;font-size: 20px;">{{ $t("message.ExchangeToDiscount") }}</strong>
      <div style="color: rgb(255 255 255 / 0%);">..........................</div>
    </div>
    <!-- start success .-->
      <div v-if="success" class="content" :style="'padding-top: 60px;border: 1px solid '+$bgColor+';'" >
        <div style="display: flex; justify-content: center; align-items: center;">
            <img id="checkedImg"  :src="require('@/assets/checked.png')" alt="">
        </div> <br>
        <div :style="'text-align: center;font-size: 20px;color:' + $bgColor">{{ $t("message.complete") }}</div><hr >
        <v-row>
            <v-col class="text-center">
              <qrcode-usecode
                :value="qrCodeURL"
                :size="150"
              ></qrcode-usecode>
              {{ $t("message.ScanQr") }}
            </v-col>
        </v-row>

        <div style="padding: 16px 30px 0; margin: 0 20px 0;">
            <div style="display: flex; justify-content: center; align-items: center;">
                <p style="margin-right: auto;"><b>
                    {{ $t("message.DiscountEarned") }} <br>
                    {{ $t("message.PointsExchanged") }} <br>
                    {{ $t("message.remainPoint") }}</b>
                </p>
                <p style="margin-left: auto; text-align: right;">
                    {{ formatNumber(discount) }}<b class="unit">{{ $t("message.Bath") }}</b> <br>
                    {{ formatNumber(exchangePoints) }}<b class="unit">{{ $t("message.point") }}</b><br>
                    {{ formatNumber(remain) }}<b class="unit">{{ $t("message.point") }}</b>
                </p>
            </div>
        </div>

        <v-btn @click="$router.push('/Home').catch(()=>{})" :style="'margin: 10px 15px;width: calc(100% - 30px);color:' + $textcolor+';background-color:' + $bgColor +';' " >{{ $t("message.backToHomePage") }}</v-btn>
      </div>
      <!-- end success -->

      <!-- start redeem -->
    <div v-else class="content" style="padding-top: 60px;" >
      <div style="display: flex; justify-content: center; align-items: center;" >
        <div :style="$isTargetShop ?'background-color: #fff; border-radius:50px;  margin-top: -110px;':''">
        <img  v-if="!isTargetShop" :src="require('@/assets/star.png')" alt="" style="width: 80px; height: 80px; margin-top: -110px;">
        <img
          v-else
          style="
            border-color: white;
            height: 75px;
          "
          class="pa-1"
          alt="Avatar"
          :src="require('@/assets/Vector.svg')"
        />
        </div>
      </div>
      <!-- display points -->
      <div :style="'text-align: center;font-size: 20px;color:' + $bgColor">{{ $t("message.currntPoint") }}<h2 :style="'font-size: 2rem;color:' + $bgColor" >{{ formatNumber(newData.currentPoint) }} </h2>{{ $t("message.point") }}</div>
      <div >
        <p :style="'margin-left:15px;color:'+$bgColor+';' ">{{ $t("message.point") }} <v-icon @click="showDetails" :style="'color:'+$bgColor ">mdi-help-circle-outline</v-icon></p>
        <v-text-field
            :label="$t('message.EnterPoints')"
            v-model="exchangePoints"
            :rules="[rules.point]"
            variant="outlined"
            :maxlength="10"
            clearable
            style="margin: 0px 15px;"
          ></v-text-field>
          <v-btn :disabled="exchangePoints === null ||isNaN(exchangePoints)|| checkExchangeRate === false || exchangePoints > member.currentPoint || exchangePoints < ExchangeRate" @click="RedeemDiscount()" :style="'margin: 10px 15px;width: calc(100% - 30px);color:' + $textcolor+';background-color:' + $bgColor +';'"
            :loading = "Isloading">
            {{ $t("message.ExchangeToDiscount") }}
          </v-btn>
          <p :style="'margin-left:15px;color:'+$bgColor+';' ">{{ $t("message.Discount") }}</p>
          <div class="discount" :style="'margin-left:15px;border: 1px solid '+$bgColor+';' ">
            <!-- cal -->
            <div v-if="checkExchangeRate" style="display: flex; justify-content: center; align-items: center;padding: 10px;">
              <h5 style="margin-right: auto;" >{{ formatNumber(Math.floor(exchangePoints/ExchangeRate)) }} {{ $t("message.Bath") }}</h5>
              <img :src="require('@/assets/discount.png')" alt="" width="40px" style="margin-left: auto;">
            </div>
            <div v-else style="color: crimson;display: flex; justify-content: center; align-items: center;padding: 10px;">
              <h5 style="margin-top: 10px;font-size: 15px;margin-right: auto;" >{{ $t("message.ContactStaffMessage") }}</h5>
            </div>
            <p v-show="checkExchangeRate" :style="'color:' + $bgColor +';display:inline;font-size: 12px;'" >* {{ $t("message.RateExchange") }} {{ ExchangeRate }} {{ $t("message.point") }} : 1 {{ $t("message.Bath") }}</p>
          </div>
        </div>
      </div>
      <!-- end redeem discount -->
  </div>
  </div>

</template>

<script>
import axios from 'axios'
import { mapGetters, mapActions } from 'vuex'
import Swal from 'sweetalert2'
import Qrcode from 'qrcode.vue'
// import moment from 'moment-timezone'
export default {
  name: 'ExchangeToDiscount',
  components: {
    'qrcode-usecode': Qrcode
  },
  data () {
    return {
      Isloading: false,
      checkExchangeRate: true,
      remain: 0,
      discount: 0,
      exchangePoints: null,
      selection: 0,
      overlay: true,
      dialog: true,
      b: false,
      items: null,
      memberId: null,
      DateNow: new Date(),
      shopId: null,
      profile: null,
      member: null,
      theme: null,
      month: null,
      qrCodeURL: '',
      show: false,
      shopData: null,
      success: false,
      back: true,
      rewardCode: 0,
      ExchangeRate: [],
      ExchangeRateData: [],
      rewardId: 0,
      rules: {
        point: value => {
          if (!value) return (() => { return this.$t('message.InputPoint') })()
          const pattern = /^\d+$/
          return (pattern.test(value) && parseFloat(value) <= parseFloat(this.member.currentPoint) && parseFloat(value) > 0) || (() => { return this.$t('message.InvalidInput') })()
        }
      }
    }
  },
  // eslint-disable-next-line space-before-function-paren
  async mounted() {
    // this.shopData = this.GET_THEME()
    // if (this.shopData.loyverseStatus === 'True') {
    //   await axios
    //     .post(this.DNS_IP + `/update/loyversPoint/${this.profile.memberId}`)
    //     .then(function (response) {
    //     })
    // }
    window.scrollTo(0, 0)
    // this.month = moment().format('YYYY-MM')
    // if (this.$route.query.reload === 'true') {
    //   this.$router.replace('/')
    //   location.reload()
    // }
    // await this.chckmember()
    // alert(this.shopId)
    // console.log('gggggg0')
    this.member = this.GET_MEMBERINFO()
    // console.log('gggggg1', this.member)
    this.profile = this.getLiffProfile()
    // console.log('gggggg2', this.member)
    this.shopId = this.GET_SHOPID()
    // console.log('gggggg3', this.member)
    this.theme = this.GET_THEME()

    await this.getExchangeRate()
  },
  computed: {
    metaInfo () {
      return {
        meta: [
          {
            property: 'og:title',
            content: this.pageTitle
          },
          {
            property: 'og:image',
            content: this.pageImage
          }
        ]
      }
    },
    newData () {
      return this.GET_MEMBERINFO()
    }
  },
  methods: {
    ...mapGetters('lineStore', ['liffIsReady', 'getLiffProfile']),
    ...mapActions('lineStore', ['setProfile']),
    ...mapActions('memberStore', ['getMemberProfile']),
    ...mapGetters('memberStore', ['GET_MEMBERINFO']),
    ...mapGetters('shopStore', ['GET_SHOPID', 'GET_THEME']),

    backBtn () {
      window.history.back()
    },
    async RedeemDiscount () {
      Swal.fire({
        title: '<h5>' + this.$t('message.DiscountAlert') + '</h5>',
        icon: 'question',
        allowOutsideClick: false,
        showCancelButton: true,
        width: '300px',
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#b3b1ab',
        cancelButtonText: `${this.$t('message.cancle')}`,
        confirmButtonText: `${this.$t('message.confirm')}`
      }).then(async (result) => {
        if (result.isConfirmed) {
          this.Isloading = true
          await this.calDiscount()
          await this.calCurrentPoints()
          await this.addData()
        }
      })
    },
    async getExchangeRate () {
      try {
        let response = await axios.get(
          this.DNS_IP +
          '/productExchangeRate/get?shopId=' +
          this.shopId +
          '&changePointTodiscount=true'
        )
        let rs = response.data
        if (rs[0]) {
          this.ExchangeRateData = rs
          this.ExchangeRate = rs[0].exchangeRate
          this.checkExchangeRate = true
        } else {
          this.checkExchangeRate = false
        }
      } catch (error) {
        console.error(error)
      }
    },
    calDiscount () {
      this.discount = Math.floor(this.exchangePoints / this.ExchangeRate)
      // console.log('discount :', this.discount)
    },
    calCurrentPoints () {
      this.remain = this.newData.currentPoint - this.exchangePoints
      // console.log('remain :', this.remain)
    },
    showDetails () {
      Swal.fire({
        html: `
          <div style="font-size: 11px;">
            <p style="text-align: left;">${this.$t('message.DetailPoint')}</p>
          </div>`,
        icon: 'info',
        width: '300px',
        confirmButtonText: `${this.$t('message.confirm')}`,
        confirmButtonColor: '#3085d6'
      })
    },
    async addData () {
      const body = {
        'shopId': this.shopId,
        'memberId': this.profile.memberId,
        'exchangePoints': parseInt(this.exchangePoints),
        'discount': this.discount,
        'exchangeRate': this.ExchangeRate,
        'prefix': Date.now().toString().substr(9, 13)
      }

      const result = await this.callBeTaskAPI('post', `/productExchangeRate/post`, body)
      if (result && result.status === true) {
        this.rewardId = result.rewardId
        this.rewardCode = result.rewardCode
        // console.log('restest123', result)
        // console.log('rewardId', this.rewardId)
        // console.log('rewardCode', this.rewardCode)

        this.qrCodeURL = this.ADMIN_IP + `/Master/trade?shopId=${this.shopId}&rewardId=${this.rewardId}&rewardCode=${this.rewardCode}&memberId=${this.profile.memberId}`
        this.success = !this.success
        this.back = !this.back
        this.Isloading = false
      } else {
        // handle error
        Swal.fire({
          title: '<h5>' + `${this.$t('message.error')}` + '</h5>',
          text: `${this.$t('message.TryAgain')}`,
          icon: 'error',
          width: '300px',
          confirmButtonText: `${this.$t('message.confirm')}`,
          confirmButtonColor: '#3085d6'
        }).then((result) => {
          if (result.isConfirmed) {
            this.Isloading = false
          }
        })
      }
    }
  }
}
</script>

<style scoped>
.btnActive {
  border: 2px solid #871b12;
}
@keyframes bounce4 {
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-15px);
  }
}
@keyframes bounce3 {
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(5px);
  }
}
@keyframes bounce2 {
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-5px);
  }
}
@keyframes bounce {
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(5px);
  }
}
@keyframes popin {
    0% {
        width: 0;
        height: 0;
    }
    100% {
        width: 150px;
        height: 150px;
    }
}
#checkedImg {
    animation: popin 0.5s ease forwards;
}

.bubble1 {
  animation: bounce 5s infinite alternate;
}
.bubble2 {
  animation: bounce2 3s infinite alternate;
}
.bubble3 {
  animation: bounce2 2s infinite alternate;
}
.bubble4 {
  animation: bounce2 6s infinite alternate;
}
.content {
  background: white;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  width: calc(100% - 30px);
  height: 650px;
  border-radius: 15px;
  margin: 40px 0px 0px 15px;
  justify-content: center;
}
.discount{
  background: white;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  width: calc(100% - 30px);
  height: 60px;
  border-radius: 15px;
  margin: 10px 0px;
}
#checkedImg{
  width: 60px;
  height: 60px;
}
.unit {
    display: inline-block;
    width: 60px;
}

</style>



// WEBPACK FOOTER //
// src/components/Home/ExchangeToDiscount.vue